<script setup lang="ts">
import AllianceList from '@/components/Sections/Diplomacy/Alliances/AllianceList.vue'

</script>

<template>
  <div class="pb-2 pt-1 w-full xl:w-2/3 mx-auto">
    <AllianceList />
  </div>
</template>

<style scoped lang="scss"></style>
